export const composePlayStoreUrl = () =>
	process.env.REACT_APP_PLAYSTORE_APP_URL || "";

export const composeAppStoreUrl = () =>
	process.env.REACT_APP_APPSTORE_APP_URL || "";
